import { get } from 'lodash';
import * as React from 'react';
import { format } from 'date-fns';
import { Prompt } from 'react-router';
import { reduxForm } from 'redux-form';
import { Card } from 'material-ui/Card';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withProps } from 'recompose';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer';

import { DogsFormBasic } from '@modules/dogs/DogsFormBasic';

import * as T from '@modules/dogs/_dogsTypes';
import { getDog } from '@modules/dogs/_dogsActions';
import ExportButton from '@components/exportButton/ExportButton';

const enhance = compose<T.DogsFormProps, T.Outter & T.DogsFormProps>(
  entityDetailEnhancer<T.DogEnhancerProps<T.Dog>, T.Dog>({
    getEntity: getDog,
    defaultEntity: {}
  }),
  breadcrumbs(({ entity }) => [{ label: 'Psi', to: '/dogs' }, { label: get(entity, 'name', 'Nový pes') }]),
  withProps<{}, T.DogProps>(({ entity }) => ({
    initialValues: {
      ...entity
    },
    maxYear: format(new Date(), 'YYYY')
  })),
  reduxForm({
    form: 'module-dogs'
  })
);

const View: React.SFC<T.DogsFormProps> = props => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    <form className="layout" onSubmit={props.handleSubmit}>
      <Card>
        <DogsFormBasic {...props} />
        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} />
        {props.entity && (
          <div style={{ display: 'inline-block', margin: '16px 0 16px 16px' }}>
            <ExportButton
              location="dogDetail"
              formName="form.module-dogs"
              urlPrefix="/metropolis"
              exportLabel="Export"
              input={{ dogId: props.entity.id }}
              disabled={!props.entity.id}
            />
          </div>
        )}
      </Card>
    </form>
  </div>
);

export const DogsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/dogs/DogsForm.tsx